<template>
  <div
    class="tw-flex tw-items-center tw-py-6 tw-gap-6 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-6"
  >
    <div
      class="tw-flex tw-items-center"
      :style="`width: ${columns[0].width}`"
    >
      {{ faq.short_name }}
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ faq.human_order }}
    </div>

    <div :style="`width: ${columns[2].width}`">
      <i-badge
        :type="faq.enabled ? 'success' : 'default'"
        class="tw-w-fit"
      >
        {{ faq.enabled ? $t('common.values.yes') : $t('common.values.no') }}
      </i-badge>
    </div>

    <div :style="`width: ${columns[3].width}`">
      <div
        class="tw-flex tw-items-center tw-gap-2"
      >
        <router-link :to="`/administration/internal/faq/${faq.id}`">
          <i-button
            type="white"
            is-icon
          >
            <icon-edit />
          </i-button>
        </router-link>
        <i-confirm-popover
          :cancel-text="$t('common.actions.cancel')"
          :submit-text="$t('common.actions.delete')"
          @submit="deleteFaq"
        >
          <template #reference>
            <i-button
              type="white"
              is-icon
              class="tw-text-primary"
              :is-loading="isDeleting"
            >
              <icon-trash />
            </i-button>
          </template>
          <template #content>
            <div>
              {{ $t('adm.permits.faq.delete_dialog.confirm_text') }}
              {{ faq.short_name }}
            </div>
          </template>
        </i-confirm-popover>
      </div>
    </div>
  </div>
</template>

<script>

import { getValidationError } from '@/helpers';

export default {
  name: 'InternalFaqListItem',
  props: {
    faq: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isDeleting: false,
    };
  },

  methods: {
    async deleteFaq() {
      this.isDeleting = true;
      try {
        await this.$store.dispatch('v2/admin/cms/internal/faq/deleteFaq', this.faq.id);
      } catch (e) {
        const errorText = getValidationError(e);

        this.$message.error({
          message: errorText,
          showClose: true,
          dangerouslyUseHTMLString: true,
        });
      } finally {
        this.isDeleting = false;
      }
    },
  },
};
</script>
